import { AbstractControl, AsyncValidatorFn, ValidatorFn, Validators } from "@angular/forms";
import { of } from "rxjs";

import { ValidatorFactory } from "../../interface/validator-factory.interface";
import { AsyncValidationError } from "../../interface/type/async-validation-error.type";
import { SyncValidationError } from "../../interface/type/sync-validation-error.type";

	/**
	 * @description
	 *  Validador para el ID de la causa de una nota de CyR/NC.
	 */

export class OrderEventTypeIdValidator implements ValidatorFactory {

	constructor() {}

	public asyncValidator(control: AbstractControl): AsyncValidationError {
		return of(null);
	}

	public asyncValidators(): AsyncValidatorFn[] {
		return [
			this.asyncValidator
		];
	}

	public validator(control: AbstractControl): SyncValidationError {
		return null;
	}

	public validators(): ValidatorFn[] {
		return [
			this.validator,
			Validators.required
		];
	}
}
